import { createContext, useContext, useState } from "react";
import useSection from "../hooks/useSection";
const SectionContext = createContext();

function SectionContextProvider({children}) {
    const [section, setSection, setSectionTroughtEventClick] = useSection(null);
    
    return (
        <SectionContext.Provider value={{section, setSection, setSectionTroughtEventClick}}>
            {children}
        </SectionContext.Provider>
    )
}

export default SectionContextProvider;
export const useSessionContext = () => useContext(SectionContext);